import { datadogRum } from "@datadog/browser-rum"

export function useDatadogRum () {
  const id = process.env.VUE_APP_DATADOG_APPLICATION_ID || ""
  const token = process.env.VUE_APP_DATADOG_CLIENT_TOKEN || ""

  if (id && token) {
    datadogRum.init({
      applicationId: id,
      clientToken: token,
      site: "datadoghq.com",
      service: "datacompliance-ui",
      version: process.env.npm_package_version,
      env: process.env.VUE_APP_ENVIRONMENT,
      sampleRate: 100,
      // The trackInteractions initialization parameter enables the collection of user clicks in your application.
      // Sensitive and private data contained on your pages may be included to identify the elements interacted with.
      trackInteractions: true
    })
  }
}
